/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name BookmarkFilled
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik00IDVhMyAzIDAgMDEzLTNoMTBhMyAzIDAgMDEzIDN2MTUuMWMwIDEuMjE3LTEuMzc0IDEuOTI3LTIuMzY3IDEuMjIzTDEyIDE3LjMzM2wtNS42MzMgMy45OUM1LjM3NCAyMi4wMjcgNCAyMS4zMTcgNCAyMC4xeiIvPjwvc3ZnPg==) - https://fondue-components.frontify.com/?path=/story/icons-icons--default&args=iconName:bookmark-filled
 * @see https://fondue-components.frontify.com/?path=/story/icons-icons--default - Documentation
 */
export const IconBookmarkFilled = createFondueIcon('BookmarkFilled', [["path",{"fill":"currentColor","d":"M4 5a3 3 0 013-3h10a3 3 0 013 3v15.1c0 1.217-1.374 1.927-2.367 1.223L12 17.333l-5.633 3.99C5.374 22.027 4 21.317 4 20.1z"}]]);
